import React from 'react'

export default function NoPermissionView() {
  return (
    <div className='noPermissionView'>You don't have enough permissions to view this page</div>
  )
}